// @ts-check
import React from 'react';
import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';

export default {
  uiSchema: {
    ...titleUI('Officials and faculty information'),
    'view:officialIntro': {
      'ui:description': (
        <div>
          <p>
            In the following section, you will be asked to provide information
            about faculty members if you would like to include this information
            in your application. This section refers to school governing body
            personnel, school officials, and faculty.
          </p>
        </div>
      ),
    },
  },
  schema: {
    type: 'object',
    properties: {
      'view:officialIntro': { type: 'object', properties: {} },
    },
  },
};
